import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

type Props = {
  images: string[];
  isSkuPage?: boolean;
};
export const ProductShowcaseSlideshow = ({
  images,
  isSkuPage = false,
}: Props) => {
  if (images.length === 0) return undefined;

  return (
    <div
      className={`${
        isSkuPage
          ? 'h-full max-h-[315px] md:max-h-[300px]'
          : 'h-[225px] sm:h-[275px] md:h-[350px]'
      } w-full `}
    >
      <Fade
        cssClass={`${
          isSkuPage
            ? 'h-full max-h-[315px] md:max-h-[300px]'
            : 'h-[225px] sm:h-[275px] md:h-[350px]'
        }`}
        duration={2000}
        // transitionDuration={1000}
        autoplay={true}
        canSwipe={false}
        infinite
        indicators={false}
        prevArrow={<></>}
        nextArrow={<></>}
      >
        {images.map((src, ix) => (
          <img
            src={src}
            key={ix}
            className={`${
              isSkuPage
                ? 'h-full max-h-[315px] md:max-h-[300px] md:rounded-[10px]'
                : 'h-[225px] sm:h-[275px] md:h-[350px]'
            } w-full object-cover`}
          />
        ))}
      </Fade>
    </div>
  );
};
